/**
 * Format a Date as a value for an `<input type="datetime-local">`.
 *
 * A datetime-local input interprets its value in the browser's local timezone.
 * Using `Date.prototype.toISOString()` here would feed a UTC string into a
 * local-time field, shifting the displayed (and later stored) time by the
 * timezone offset — e.g. -2h in German summer time (CEST = UTC+2).
 */
export function toLocalDatetimeInput(date: Date): string {
  const offsetMs = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offsetMs).toISOString().slice(0, 16);
}
